import { ITranslations } from 'types/common';
import { BrandRequestFormTransFields } from './types';
import en from 'translations/en/brandBasicForm.json';
import pl from 'translations/pl/brandBasicForm.json';
import sl from 'translations/sl/brandBasicForm.json';

export const brandRequestFormTranslations: ITranslations<BrandRequestFormTransFields> = {
  name: 'brandRequestForm',
  en,
  pl,
  sl,
};
